module.exports = __webpack_public_path__ + "img/marketing.5ac4701b.svg";